"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QUEUE_INCOMING_ACTIVITY = void 0;
exports["default"] = queueIncomingActivity;
var QUEUE_INCOMING_ACTIVITY = 'DIRECT_LINE/QUEUE_INCOMING_ACTIVITY';
exports.QUEUE_INCOMING_ACTIVITY = QUEUE_INCOMING_ACTIVITY;
function queueIncomingActivity(activity) {
  return {
    type: QUEUE_INCOMING_ACTIVITY,
    payload: {
      activity: activity
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJRVUVVRV9JTkNPTUlOR19BQ1RJVklUWSIsImV4cG9ydHMiLCJxdWV1ZUluY29taW5nQWN0aXZpdHkiLCJhY3Rpdml0eSIsInR5cGUiLCJwYXlsb2FkIl0sInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2FjdGlvbnMvcXVldWVJbmNvbWluZ0FjdGl2aXR5LmpzIl0sInNvdXJjZXNDb250ZW50IjpbImNvbnN0IFFVRVVFX0lOQ09NSU5HX0FDVElWSVRZID0gJ0RJUkVDVF9MSU5FL1FVRVVFX0lOQ09NSU5HX0FDVElWSVRZJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gcXVldWVJbmNvbWluZ0FjdGl2aXR5KGFjdGl2aXR5KSB7XG4gIHJldHVybiB7XG4gICAgdHlwZTogUVVFVUVfSU5DT01JTkdfQUNUSVZJVFksXG4gICAgcGF5bG9hZDogeyBhY3Rpdml0eSB9XG4gIH07XG59XG5cbmV4cG9ydCB7IFFVRVVFX0lOQ09NSU5HX0FDVElWSVRZIH07XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQSxJQUFNQSx1QkFBdUIsR0FBRyxxQ0FBcUM7QUFBQ0MsT0FBQSxDQUFBRCx1QkFBQSxHQUFBQSx1QkFBQTtBQUV2RCxTQUFTRSxxQkFBcUJBLENBQUNDLFFBQVEsRUFBRTtFQUN0RCxPQUFPO0lBQ0xDLElBQUksRUFBRUosdUJBQXVCO0lBQzdCSyxPQUFPLEVBQUU7TUFBRUYsUUFBUSxFQUFSQTtJQUFTO0VBQ3RCLENBQUM7QUFDSCJ9